import { gql } from 'graphql-request'

export const GetAllowedStationsGql = gql`
  query allowedStations {
    allowedStations {
      results {
        recordNumber
        tradingName
        brand
        roles
      }
      welcomeMessage
    }
  }
`
